import { render, staticRenderFns } from "./CustomerApprovalTypes.vue?vue&type=template&id=9d27eada"
import script from "./CustomerApprovalTypes.vue?vue&type=script&lang=js"
export * from "./CustomerApprovalTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports